@if (item.customField15=='1') {
<div>
  <div fxLayout="column" fxLayout.gt-sm="row" [style.background-color]="item.customField17" style="padding: 30px;">
    <div fxFlex="100" fxFlex.gt-sm="50" contentAnim [aniName]="item.customField36">
      <h2 [style.font-size]="item.customField27" [ngStyle.lt-md]="{ 'font-size': item.customField29 }">
        <b>{{item.customField16}}</b></h2>
    </div>
    <div fxFlex="100" fxFlex.gt-sm="10">
    </div>
    <div fxFlex="100" fxFlex.gt-sm="40" style="padding-top: 20px;" contentAnim [aniName]="item.customField36">
      @if (item.customField6==0) {
      <button mat-raised-button color="primary" [style.font-size]="item.customField22"
        [ngStyle.lt-md]="{ 'font-size': item.customField23 }" (click)="callToFunction(0,item.customField11)"
        [innerHTML]="item.title" class="smcss"></button>
      }
      @if (item.customField6==1) {
      <button mat-raised-button color="primary" [style.font-size]="item.customField22"
        [ngStyle.lt-md]="{ 'font-size': item.customField23 }" (click)="callToFunction(1,item.customField5)"
        [innerHTML]="item.title" class="smcss"></button>
      }
    </div>
  </div>
</div>
}
@if (item.customField15=='3') {
<div>
  <div [style.background-color]="item.customField17" style="padding: 30px;text-align: center;" contentAnim
    [aniName]="item.customField36">
    <h6 [style.color]="item.customField20" [style.font-size]="item.customField27"
      [ngStyle.lt-md]="{ 'font-size': item.customField29 }"><b>{{item.customField16}}</b></h6>
    <div [style.color]="item.customField20" [style.font-size]="item.customField30"
      [ngStyle.lt-md]="{ 'font-size': item.customField31 }">
      <calsoft-editor-text [data]="data" [text]="item.customField19"></calsoft-editor-text>
    </div>
  
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxLayoutAlign="center center" style="align-items: center;
      justify-content: center;
      gap: 10px;">
      <button style="border-radius: 10px;" mat-raised-button [style.font-size]="item.customField27"
        [ngStyle.lt-md]="{ 'font-size': item.customField29 }" [style.background-color]="item.customField21"
        [style.color]="item.customField20" style="margin-top: 20px;" (click)="(item.customField6 == 0) ? link(item.customField11) 
          : (item.customField6 == 1) ? dynamicFormPopup(item.customField5) 
          : (item.customField6 == 2) ? scrollDown(item.customField35): null">{{item.title}} &#160;
        @if (item.customField18) {
        <mat-icon [style.color]="item.customField20"
          style="font-size: 20px;margin-top: 4px;">{{item.customField18}}</mat-icon>
        }
      </button>
  @if(crmis == true)
    {
      <button style="border-radius: 10px;" mat-raised-button [style.font-size]="item.customField27"
        [ngStyle.lt-md]="{ 'font-size': item.customField29 }" [style.background-color]="item.customField21"
        [style.color]="item.customField20" style="margin-top: 20px;" (click)="scrollDown('gotoform ')">Connect With Us</button>

    }
    </div>
    
    


  </div>
</div>
}

@if (item.customField15=='5') {
<div>
  <div fxLayout="column" fxLayout.gt-sm="row" [style.background-color]="item.customField17" style="padding: 30px;">
    <div fxFlex="100" fxFlex.gt-sm="40" contentAnim [aniName]="item.customField36">
      <h2 [style.font-size]="item.customField27" [ngStyle.lt-md]="{ 'font-size': item.customField29 }">
        <b>{{item.customField16}}</b></h2>
    </div>
    <div fxFlex="100" fxFlex.gt-sm="10">
    </div>
    <div fxFlex="100" fxFlex.gt-sm="10" style="padding-top: 20px;" contentAnim [aniName]="item.customField36">
      <button mat-raised-button [style.background-color]="item.customField24"
        (click)="callToFunction(0,item.customField11)" class="smcss" [style.font-size]="item.customField22"
        [ngStyle.lt-md]="{ 'font-size': item.customField23 }" style="color: white;">{{item.title}}</button>
    </div>
    <div fxFlex="100" fxFlex.gt-sm="10" style="padding-top: 20px;" contentAnim [aniName]="item.customField36">
      <button mat-raised-button [style.background-color]="item.customField25"
        (click)="callToFunction(0,item.customField26)" class="smcss" [style.font-size]="item.customField22"
        [ngStyle.lt-md]="{ 'font-size': item.customField23 }" style="color: white;">{{item.customField23}}</button>
    </div>
    <div fxFlex="100" fxFlex.gt-sm="20">
    </div>
  </div>
</div>
}

@if (item.customField15=='7') {
<div class="container-new" style="padding:3rem 7rem;" [ngStyle.lt-md]="{ 'padding': '1rem' }" contentAnim
  [aniName]="item.customField36">
  <div fxLayout.lt-md="column" fxLayout.gt-sm="row" fxLayoutAlign="space-between center"
    [style.background-color]="item.customField17" class="button7" [ngStyle.lt-md]="{ 'padding': '15px','gap':'10px' }"
    style="padding: 20px; border-radius: 60px;">
    <div fxFlex="100" [ngStyle.lt-md]="{ 'text-align': 'center' }" [ngStyle.gt-md]="{ 'padding-left': '2rem' }">
      <calsoft-editor-text [style.font-size]="item.customField27" [ngStyle.lt-md]="{ 'font-size': item.customField29 }"
        [data]="data" [text]="item.customField16"></calsoft-editor-text>
    </div>

    <div fxFlex="100" [ngStyle.lt-md]="{ 'text-align': 'center' }" style="text-align: end;" contentAnim
      [aniName]="item.customField36">
      @if (item.customField6==0) {
      <button mat-raised-button [style.background-color]="item.customField21" [style.font-size]="item.customField22"
        [ngStyle.lt-md]="{ 'font-size': item.customField23 }" (click)="callToFunction(0,item.customField11)"
        class="smcss1">
        <calsoft-editor-text [data]="data" [text]="item.title"></calsoft-editor-text>
      </button>
      }
      @if (item.customField6==1) {
      <button mat-raised-button [style.background-color]="item.customField21" [style.font-size]="item.customField22"
        [ngStyle.lt-md]="{ 'font-size': item.customField23 }" (click)="callToFunction(1,item.customField5)"
        class="smcss1">
        <calsoft-editor-text [data]="data" [text]="item.title"></calsoft-editor-text>
      </button>
      }
    </div>
  </div>
</div>
}
